export default "__VITE_ASSET__cvrsWD6F__"